<template>
  <div id="platformContent">
    <!--页头开始-->
    <el-row style="height:24%; width:100%;" v-show="loginContenVisible">
      <el-col :span="24" >
        <div class="bt-head">
            <div class="bt-head-cen" style="height: 110px;">
              <div class="top_left_fems" style="width:450px;height:120px; ">
                <a href="../">
                  <img src="~@/assets/img/logo-20180504.png" style="height: 80px;" alt="" />
                </a>
              </div>
              <div class="top_right_fems" style="width:520px;">
                <div style="font-size: 25px;width: 31%;float: right;padding-top: 14px; font-family: 'Microsoft YaHei';">
                    管理服务平台
                </div>
                <div style="text-algin:center; color:#cd0b02; width:56%;float: right;font-size: 16px;
              ">
                  <p style="letter-spacing: 20px; margin: 0px; font-family: 'Microsoft YaHei';">外国在华文化中心</p>
                  <p style="letter-spacing: 7px; margin: 0px; font-family: 'Microsoft YaHei';">外国旅游部门常驻代表机构</p>
                  <p style="letter-spacing: 2px; margin: 0px; font-family: 'Microsoft YaHei';">港澳台地区旅游部门常驻代表机构</p>
                </div>
              </div>
            </div>
          </div>
          <!--导航开始-->
            <div class="bt-nav-y" style="background:#9d1515">

            </div>
          <!--导航结束-->
      </el-col>
    </el-row>
    <!--页头结束-->
    <!--系统标题  -->
    <!--main  -->
    <el-row style="height: 300px;width: 1200px;margin: 0 auto;background: url('/img/banner.png')" type="flex" justify="center" v-show="loginContenVisible">
      <el-col :span="2" style="background-color: rgba(255,255,255,0.3);">
      </el-col>
      <el-col :span="11" style="background-color: rgba(255,255,255,0.3);">
        <div class="tongzhi">
                <div class="tongzhiTitle">
                    <span class="tongzhiLeft">通知公告</span>
                    <!-- <a class="tongzhiRight" href="/index/more?t=0"
                    >更多>></a> -->
                    <span style="font-size:16px; cursor:pointer;
                    float: right!important; font-family: 'Microsoft YaHei';"
                    :class="{mouseActive:isNoticeMoreMouseActive}"
                    @mouseenter="noticeMouseEnter()"
                    @mouseleave="noticeMouseLeave()"
                    @click="jumpToPage('notice')">更多>></span>
                </div>
                <div style="clear:left;"></div>
               <div >
                   <ul v-for="(n,index) in noticeData" :key="index"
                   style="">
                     <el-row class="infoRowStyle">
                       <li style="width:100%;cursor:pointer; list-style-type:none;"
                         @click="jumpToPage('noticeDetail',n.id)"
                         @mouseenter="noticeMouseEnter(index)"
                         @mouseleave="noticeMouseLeave(index)">
                         <el-col :span="18" >
                           <div class="liInfo" :class="{mouseActive:index==isNoticeTitleMouseActive}">
                             {{n.title}}
                           </div>
                         </el-col>
                       <el-col :span="6">
                         <div style="float:center;">
                           <span>{{n.releaseTime}}</span>
                         </div>
                       </el-col>
                       </li>
                     </el-row>
                   </ul>
               </div>

        </div>
      </el-col>
      <el-col :span="1" style="background-color: rgba(255,255,255,0.3);">
      </el-col>
      <el-col :span="7" style="background-color: rgba(255,255,255,0.3);">
        <div
          style="margin:0px 0px 0px 0px;
          height:90%;

          position: relative;
          padding-bottom:20px;">

          <el-form  status-icon  :model="loginForm" ref="loginForm"
          label-width="90px" id="loginForm"
          style="margin:30px 50px 0px 0px; font-family: 'Microsoft YaHei'; color:#333333;">
            <el-form-item label="用户名" prop="pass" style="color:#333333;">
              <el-input type="text"  ref="usernameRef"
              v-model="loginForm.username"
              placeholder="请输入用户名..."
              autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input type="password"
              ref="passwordRef"
              v-model="loginForm.password"
              placeholder="请输入密码..."
              autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码">
              <el-col :span="15">
                <el-input
                type="text"
                ref="identifyRef"
                v-model="loginForm.identify"
                placeholder="验证码...">
                </el-input>
              </el-col>
              <el-col :span="9">
                <div class="code" @click="refreshCode">
                  <s-identify :identifyCode="identifyCode"></s-identify>
                </div>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button  @click="submitForm('ruleForm')"
               style="background:#DE2C16; width:100%; color:white;">登录</el-button>
            </el-form-item>
          </el-form>

        </div>
      </el-col>
      <el-col :span="1" style="background-color: rgba(255,255,255,0.3); padding-top:30px;">
        </el-col>
    </el-row>


    <el-row style="height: 29%;width: 1200px;margin: 0 auto;" type="flex" justify="center" v-show="loginContenVisible">
        <el-col :span="1" style="background:white; padding-top:30px;">
          </el-col>
      <el-col :span="6" style="background:white; padding-top:30px; cursor:pointer">
        <div  @click="jumpToPage('orgList1')">
        <!-- <router-link tag="a" target="_blank" :to="{name:'CompOrgList',query:{orgListVisible:true,orgType:'foreigner tourism'}}">打开新页面</router-link> -->
          <img src="~@/assets/img/small_bg1.png" height="100%" width="100%"></img>
        </div>
      </el-col>
      <el-col :span="1" style="background:white; padding-top:30px;">
      </el-col>
      <el-col :span="6" style="background:white; padding-top:30px; cursor:pointer">
        <div  class="" @click="jumpToPage('orgList2')" >
          <img src="~@/assets/img/small_bg2.png" height="100%" width="100%"></img>
        </div>
      </el-col>
      <el-col :span="1" style="background:white;padding-top:30px;">
      </el-col>
      <el-col :span="6" style="background:white; padding-top:30px; cursor:pointer">
        <div @click="jumpToPage('orgList3')">
          <img src="~@/assets/img/small_bg3.png" height="100%" width="100%"></img>
        </div>
      </el-col>
      <el-col :span="1" style="background:white;padding-top:30px;">
      </el-col>
    </el-row>
    <!--页脚开始-->
    <div  v-show="loginContenVisible">
     <el-row type="flex" justify="center" style="height:25%;">
       <el-col :span="24">
            <div class="bt-footer footer_box">
            <div class="footer_main">
            <div class="footer_pic">
              <a href="http://bszs.conac.cn/sitename?method=show&id=0895F7C11FF86C12E053012819AC7E96" target="_blank">
                <img src="~@/assets/img/dzjg.png" />
              </a>
            </div>
            <div class="footer_list">
             <div class="footer_nav">
               <ul>
                 <li><a href="https://www.mct.gov.cn/dbdh/gywm/" target="_blank">关于我们</a></li>
                 <li class="jg">|</li>

                 <li><a href="https://www.mct.gov.cn/dbdh/wzdt/" target="_blank">网站地图</a></li>

                 <li class="jg">|</li>
                 <li><a href="https://www.mct.gov.cn/dbdh/bqbh/" target="_blank">版权保护</a></li>

                 <li class="jg">|</li>
                 <li><a href="https://www.mct.gov.cn/dbdh/mzsm/" target="_blank">免责声明</a></li>

               </ul>
               <p>版权所有：中华人民共和国文化和旅游部 地址：东城区朝阳门北大街10号 邮编：100020</p>
               <p>ICP备案：京ICP备18030242号-1 电话：010-59881114</p>

                                   <div style="width:500px;">
                                       <p style="float:left;">网站标识码bm23000001</p>
               <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040202440050" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;padding-left:15px;">
                 <img src="~@/assets/img/dibiao.png" style="float:left;" />
                 <span style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#cccccc;font-size:13px;">
                   京公网安备 11040202440050号
                 </span>
               </a>
             </div>
             </div>
            </div>
            <div class="footer_jc">
                <span id="_span_jiucuo">
                  <img @click="jiucuo.Link('bm23000001')"  style="margin:0;border:0;cursor: pointer;" src="https://zfwzgl.www.gov.cn/exposure/images/jiucuo.png?v=bm23000001"></span>
            </div>

            </div>
            </div>
            <!-- // <script id="_trs_ta_js" src="//ta.trs.cn/c/js/ta.js?mpid=4419" async="async" defer="defer"></script> -->
      </el-col>
     </el-row>
    </div>
    <!--页脚结束-->
    <comp-org-List
      v-if="orgListVisible"
      :orgListVisible.sync="orgListVisible"
      :orgType="orgType"
      @returnBack="toShowLogin">
    </comp-org-List>
    <comp-notice-info
      v-if="noticeInfoVisible"
      :noticeInfoVisible.sync="noticeInfoVisible"
      :noticeID="notice"
      @returnToNoticeList="showNoticeListPage"
      @returnBack="toShowLogin">
    </comp-notice-info>
    <comp-notice-list
      v-if="noticeListVisible"
      :noticeListVisible.sync="noticeListVisible"
      :noticeType="noticeType"
      @returnToNoticeInfo="getNoticeInfo"
      @returnBack="toShowLogin"
      >
    </comp-notice-list>
  </div>
</template>
<script>
import CompOrgList from '../comp/LoginOrgList';
import CompNoticeInfo from '../comp/LoginNoticeInfo';
import CompNoticeList from '../comp/LoginNoticeList';
import { login, logout } from '../api/Login'
import { getNoticeByID, selectPartList } from '../../console/api/notice/NotificationNotice'
import SIdentify from "../comp/identify";
import '@/assets/base/style/login/hanweb.css'
import '@/assets/base/style/login/sy_culture.css'
import {Link} from '../../yourbiz/js/jiucuo'
export default {
  components: {
    CompOrgList, //机构信息列表查询组件
    CompNoticeInfo, //通知详细信息组件
    CompNoticeList, //通知列表组件
    SIdentify: SIdentify //验证码组件
  },
  name: 'baseLoginDynamicImg',
  props: {
    // 登录成功后的调整路径
    successPath: String,
    a:Boolean,
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      orgListVisible: false, //机构列表显示隐藏控制
      loginContenVisible:true, //登录页面显示隐藏
      noticeInfoVisible: false, //通知详细信息页显示隐藏控制
      noticeListVisible: false, //通知列表信息页显示隐藏控制
      // 通知查询条件
      noticeFilters: {
        type: '',
        status: 'effective'
      },
      //政策法规数据
      noticeData:[],
      // 办事指南数据
      guideDate:[],
      // notice对象
      notice:{},
      // 办事指南鼠标移入事件控制
      isGuideMouseActive:null,
      // 政策法规鼠标移入事件控制
      isNoticeTitleMouseActive:null,
      //更多鼠标事件控制
      isNoticeMoreMouseActive:null,
      //更多鼠标事件控制
      isGuideMoreMouseActive:null,
      identifyCodes: "1234567890",
      identifyCode: "",
    }
  },
  mounted() {
    this.showNoticeList()
    var displayContent = this.$route.query.displayContent;
    var n = this.$route.query.notice;
    if(displayContent&&displayContent=='orgList1') {
      this.showOrgList(1);
    }else if(displayContent&&displayContent=='orgList2') {
        this.showOrgList(2);
    }else if(displayContent&&displayContent=='orgList3') {
        this.showOrgList(3);
    }else if(displayContent&&displayContent=='notice') {
      this.showNoticeListPage('');
    }else if(displayContent&&displayContent=='noticeDetail') {
     this.getNoticeInfo(n);
    }else{
      this.$store.dispatch('signOut').then(() => { })
      let token = sessionStorage.getItem('token');
      if (token) {
        // 清理上次登录的token
        logout().then(result => {
          sessionStorage.removeItem('token')
        })
      }
      //this.loginContenVisible = true
      // 查询政策法规列表
      //this.showNoticeList(1)
      // 查询办事指南列表
      //this.showNoticeList(2)
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    }



  },
  methods: {
    /*
    * 验证码随机数生成
    */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    /**
    * 刷新验证码
    */
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    /**
    * 生成验证码
    */
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    /**
     * 提交登录表单
     */
    submitForm() {
        if(this.loginForm.identify == undefined) {
          this.$message.error("请输入验证码");
          return;
        }
        if(this.identifyCode == this.loginForm.identify) {
          this.doLogin()
          return;
        }
        this.refreshCode();
        this.$message.error("输入验证错误");
    },
    /**
     * 异步登录处理
     */
    doLogin() {
      login(this.loginForm).then(result => {
        if (result.code === 20000) {
          sessionStorage.setItem('manager', result.data['manager']);
          sessionStorage.setItem('token', result.data['SUM-TICKET'])
          sessionStorage.setItem('param', result.data['param'])
          if(result.data['param']) {
            sessionStorage.setItem('manager', JSON.parse(result.data['param']).manager)
          }

          sessionStorage.setItem('personName', result.data['personName'])
          this.$store.commit('setToken', result.data['SUM-TICKET'])
          this.$router.push({ path: this.successPath })
        } else if (result.code === 30006) {
          sessionStorage.setItem('token', result.data['SUM-TICKET'])
          const param = JSON.parse(result.data.param)
          this.refreshCode();
        }

      })
    },
    //展示机构信息
    showOrgList(type) {
      if(type == 1) {
        this.orgType = 'cultural center'
      }else if (type == 2){
        this.orgType = 'foreigner tourism'
      }else {
        this.orgType = 'HMT tourism'
      }
      this.orgListVisible= true, //机构列表显示隐藏控制
      this.loginContenVisible=false //登录页面显示隐藏
    },
    //新窗口页面打开
    jumpToPage(page,notice) {

      const {href} = this.$router.resolve({
      name: "login",
      query: {
          displayContent: page,
          notice:notice
      }
      });
      window.open(href, '_blank');
    },
    //展示登录页面
    toShowLogin: function() {
      this.loginContenVisible=true
    },
    //展示通知标题列表
    showNoticeList(type) {
      if(type == "1") {
         this.noticeFilters.noticeType = 'policy'
      }else if(type == "2"){
        this.noticeFilters.noticeType = 'guide'
      }
      this.noticeFilters.current = 1
      this.noticeFilters.size = 10
      this.noticeFilters.contentSituation = 'registerInfoCompletion';
      selectPartList(this.noticeFilters).then(response => {
        if(type == "1") {
          this.noticeData = response.data;
        }else if(type == "2"){
          this.guideDate = response.data;
        }else {
          this.noticeData = response.data;  //合成一个通知公告了
        }
      }).catch(err => {
        console.log(err)
      });
    },
    // 获取消息详情
    getNoticeInfo(n) {

      this.notice = n
      this.noticeInfoVisible= true,
      this.loginContenVisible=false //登录页面显示隐藏
    },
    //鼠标移入事件
    guideMouseEnter(index) {
      if(index==null) {
        this.isGuideMoreMouseActive = true;
      }
      this.isGuideMouseActive = index;
    },
    //鼠标移除事件
    guideMouseLeave(index){
      if(index==null) {
        this.isGuideMoreMouseActive = null;
      }
      this.isGuideMouseActive = null;
    },
    //鼠标移入事件
    noticeMouseEnter(index) {
      if(index==null) {
        this.isNoticeMoreMouseActive = true;
      }
      this.isNoticeTitleMouseActive = index;
    },
    //鼠标移除事件
    noticeMouseLeave(index){
      if(index==null) {
        this.isNoticeMoreMouseActive = null;
      }
      this.isNoticeTitleMouseActive = null;
    },
    // 展示通知列表信息列
    showNoticeListPage(type) {
      this.noticeListVisible = true
      this.loginContenVisible=false //登录页面显示隐藏
      this.noticeType = type
    }

  }
}
</script>

<style lang="scss" scoped>
#platformContent { //网站平台内容
   width: 100%;
   height: 100%;
  overflow:auto;
}


.login_main_bg1 {
  background-image: url(~@/assets/img/login_main_bg.png);
}

.tongzhi{
  float: left;
  margin-top: 30px;
  width: 100%;
  padding: 3px 0;
  cursor: default;
  font-family: "Microsoft YaHei";
}
.tongzhiTitle{
  padding-left: 0;
  border-left: none;
  //border-bottom: 1px solid #c3cbcd;
  margin-bottom: 5px;
}
.tongzhiLeft{
    float: left!important;
    display: inline;
    font-style: normal;
    border-bottom: 3px solid #7C2323;
    font-family: "Microsoft YaHei";
}
.tongzhiRight{
  float: right!important;
    display: inline;
    color: #666!important;
    font-weight: 400;
    font-size: .9em;
    background-color: transparent;
    color: #000;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
}


/*禁止头和尾响应式布局生效开始*/
//@media only screen and (max-width:768px) {
// .bt-head{
// 	width:100%;
// 	height:auto !important;
// 	min-height:0;
// 	background: #fff !important;
// }
// .bt-head-cen{
// 	width: 1000px !important;
//     height: 117px !important;
// 	position: relative;
// 	overflow: hidden;
// 	margin:0 auto;
// }
// .top_left,.top_right,.bt-nav-y,.bt-footer{display:block !important;}
// .footer_box,.bt-head,.bt-nav-y{min-width:1000px !important;}
// }
.top_right_fems{width: 520px;height: 55px;position: absolute;right: 10px;top: 29px;}

.infoRowStyle { //办事指南、政策法规行信息样式
  border-bottom-style:dotted;
  border-width:0px 0px 1px 0px;//#FOFOFO;
  border-color:#C1C1C1;
  margin-bottom:1px 0px 1px 0px;
  height:22px;
  width:100%;
}

.liInfo { //li信息展示样式
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.top_left_fems{}
.top_left_fems img{ }



.footer_box{height:auto !important;padding-bottom:15px}
.footer_box .footer_main{width: 730px !important;}
.footer_box .footer_main .footer_pic{position: relative !important;float: left;margin: 22px 20px 0 0;left: 0;top: 0;}
.footer_box .footer_main .footer_list{float: left; margin: 15px 0 0 0;position: relative !important;left: 0;top: 0;}
.footer_jc{float: right; margin: 25px 0 0 0;}
.footer_list{width: 535px !important;}
.top_sousuo_bg{
  background-image: url(~@/assets/img/sosuo_box.jpg);
}
.top_sousuo_bg2{
  background-image: url(~@/assets/img/sosuo_s.jpg);
}

.t_chglf{float: left;font-size: 13px;color: #333333;}
.top_change{width: 1000px;margin: 0 auto;height: 35px;overflow: hidden;line-height:35px;position: relative;}
.top_right .top_link_box a{line-height:16px;}
/*禁止头和尾响应式布局生效结束*/
</style>
